module.exports = __webpack_public_path__ + "static/media/5_kolaj_10.47_82.96.a88d9536.png";